<section class="premium-3d-single-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <!-- The Ultimate 3D Glassmorphic Card -->
                <div class="ultimate-3d-card">
                    <!-- Top Image Area -->
                    <div class="card-image-header" *ngIf="inputData.ShowAttachments && inputData.ShowAttachments.length > 0">
                        <img class="img-fluid" [src]="inputData.ShowAttachments[0].FilePath" alt="{{ inputData.TitleEn }}" />
                        <!-- Floating Glass Date Badge over the image -->
                        <div class="floating-glass-badge">
                            <i class="fa-regular fa-calendar-alt me-2"></i> {{ inputData.CurrentDate | date : "MMM d, yyyy" }}
                        </div>
                    </div>
                    
                    <!-- Content Area -->
                    <div class="card-content-body">
                        <h1 class="ultimate-3d-title mb-4">
                            {{ inputData.TitleEn }}
                        </h1>
                        
                        <div class="ultimate-text-content" *ngIf="inputData.DetailsEn">
                            <div [innerHTML]="inputData.DetailsEn"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>